import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import logo from '../../assets/images/resource/sidebar-logo.png'
import logonew from '../../assets/images/logo.png'
import Banner from '../Menhome/Banner'
import Offer from '../Menhome/Offer'
import Story from '../Menhome/Story'
import Specialdish from '../Menhome/Specialdish'
import Menusection from '../Menhome/Menusection'
import Whyus from '../Menhome/Whyus'
import Teem from '../Menhome/Teem'
import Reacntupdate from '../Menhome/Recntupdates'
import Special from '../Menhome/Special'
import Contact from '../Menhome/Contact'
import Videosection from '../Menhome/Videosection'

function Main() {

    const [active, setActive] = useState();

    const [scrolled, setScrolled] = useState(false);
    const [Nav, setNav] = useState(true);

    const handleScroll = () => {
        const offset = window.scrollY;
        if (offset > 1000) {
            setNav(false)
        }
        else if (offset > 200) {
            setNav(true);
            setScrolled(true);
        }
        else {
            setScrolled(false);
            setNav(true);
        }
    }

    useEffect(() => {
        window.addEventListener('scroll', handleScroll)
    })

    return (
        <>
            {active &&
            <div className="menu-backdrop" style={{ opacity: "1", visibility: "visible" }} onClick={() => setActive(false)}></div>}
            <section className={`hidden-bar ${active && "visible-sidebar"}`} onClick={() => setActive(false)} >
                <div className="inner-box">
                    <div className="cross-icon hidden-bar-closer" onClick={() => setActive(false)} ><span className="far fa-close"> </span></div>
                    <div className="logo-box"><Link to="/" title="BonAppetit"><img src={logo} alt="" title="BonAppetit" />
                    </Link></div>

                    <div className="side-menu">
                        <ul className="navigation clearfix">
                            <li className="current"><Link to="/" onClick={() => setActive(false)}>Početna</Link></li>
                            <li><Link to="/menu" onClick={() => setActive(false)}>Meni</Link></li>
                            <li><Link to="/about">O nama</Link></li>
                            <li><Link to="/contact">Kontakt</Link></li>
                        </ul>
                    </div>

                    <h2>Posetite nas</h2>
                    <ul className="info">
                        <li>Ivana Gundulića 7, <br /> Smederevo 230437 </li>
                        <li>Radno vreme: 08:00 - 22:30</li>
                    </ul>
                    <div className="separator"><span></span></div>
                    <div className="booking-info">
                        <div className="bk-title">Poručite na broj</div>
                        <div className="bk-no"><Link to="tel:+381 64 1856 290">+381 64 1856 290</Link></div>
                    </div>

                </div>
            </section>

            {Nav &&
                <header className={`main-header ${scrolled && "fixed-header"} header-down`}>
                    <div className="header-top">
                        <div className="auto-container">
                            <div className="inner clearfix">
                                <div className="top-left clearfix">
                                    <ul className="top-info clearfix">
                                        <li><i className="icon far fa-map-marker-alt"></i> Ivana Gundulića 7, Smederevo 230437</li>
                                        <li><i className="icon far fa-clock"></i> Radno vreme : 08:00 - 22:30</li>
                                    </ul>
                                </div>
                                <div className="top-right clearfix">
                                    <ul className="top-info clearfix">
                                        <li><Link to="tel:+11234567890"><i className="icon far fa-phone"></i> +381 64 1856 290</Link></li>
                                        <li><a href="https://glovoapp.com/rs/en/smederevo/bon-appetit-smd/" target="_blank" rel="noopener noreferrer">Glovo</a></li>
                                        <li><a href="https://wolt.com/sr/srb/smederevo/restaurant/bon-appetit-smederevo?srsltid=AfmBOoqrxFzCZCweBtLFJjMRJEOyTajPItBmoEv6whAbOqG2XbhA_dsD" target="_blank" rel="noopener noreferrer">Wolt</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="header-upper">
                        <div className="auto-container">

                            <div className="main-box clearfix">
                                <div className="logo-boxtwo">
                                    <div className="logo"><Link to="/hometwo" title="BonAppetit"><img src={logonew} alt="" title="BonAppetit" /></Link></div>
                                </div>

                                <div className="nav-boxtwo clearfix">

                                    <div className="nav-outertwo clearfix">
                                        <nav className="main-menu">
                                            <ul className="navigation clearfix">
                                                <li className="current"><Link to="/hometwo">Home</Link>
                                                </li>
                                                <li><Link to="/menu">Meni</Link></li>
                                                <li><Link to="/about">O nama</Link></li>
                                                <li><Link to="/contact">Kontakt</Link></li>
                                            </ul>
                                        </nav>
                                    </div>

                                    <div className="links-boxtwo clearfix">
                                        {/* <div className="link link-btn">
                                            <Link to="/reservation" className="theme-btn btn-style-one clearfix">
                                                <span className="btn-wrap">
                                                    <span className="text-one">find a table</span>
                                                    <span className="text-two">find a table</span>
                                                </span>
                                            </Link>
                                        </div> */}
                                        <div className="link info-toggler">
                                            <button className="info-btn">
                                                <span className="hamburger">
                                                    <span className="top-bun"></span>
                                                    <span className="meat"></span>
                                                    <span className="bottom-bun"></span>
                                                </span>
                                            </button>
                                        </div>
                                    </div>

                                    <div className="nav-togglertwo">
                                        <button className="hidden-bar-opener">
                                            <span className="hamburger">
                                                <span className="top-bun"></span>
                                                <span className="meat"></span>
                                                <span className="bottom-bun"></span>
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
            }

            <Banner />
            <Offer />
            <Story />
            <Specialdish />
            <Menusection />
            <Special />
            <Contact />
            <Whyus />
            <Teem />
            <Videosection />
            <Reacntupdate />
        </>
    )
}

export default Main